import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogItemInstanceRef } from "./CatalogItemInstanceRef";
import type { CatalogItemInstanceStaff } from "./CatalogItemInstanceStaff";
import type { PurchasableState } from "./PurchasableState";
import type { StockChangeDTOBase } from "./StockChangeDTOBase";
import type { StockChangeType } from "./StockChangeType";
import type { TrackedModernBase } from "./TrackedModernBase";

export class StockChangeStaff implements StockChangeDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly changeAmount: number, public readonly stockChangeType: StockChangeType, public readonly purchasableState: PurchasableState | null, public readonly purchaseDate: Date | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly itemInstanceId: CatalogItemInstanceStaff | null, public readonly itemInstanceIdTargetIds: CatalogItemInstanceRef) {
    this.cbiServiceContext = null;
    this.itemInstanceIdLoaded = this.itemInstanceId != null;
    this.itemInstanceIdCached = this.itemInstanceId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemInstanceIdLoaded: boolean;
  private itemInstanceIdCached: CatalogItemInstanceStaff | null;
  async itemInstanceIdLazy(): Promise<CatalogItemInstanceStaff> {
    if (!this.itemInstanceIdLoaded) {
      this.itemInstanceIdCached = await this.cbiServiceContext!.catalogService().getCatalogItemInstanceStaff(this.itemInstanceIdTargetIds.assignId);
      this.itemInstanceIdLoaded = true;
    }
    return this.itemInstanceIdCached!;
  }
}
